<widget-header
  [name]="widgetName"
  [editable]="isEditable">

  <widget-menu
    slot="menu"
    [resource]="resource">
  </widget-menu>
</widget-header>

<div class="op-widget-box--body -allow-inner-overflow">
  <turbo-frame [id]="frameId" [src]="src"></turbo-frame>
</div>
